import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@app/shared';
import {ExampleStampComponent} from '@entities/example-stamp/example-stamp/example-stamp.component';
import {ExampleStampRoute} from '@entities/example-stamp/example-stamp.route';
import {RouterModule, Routes} from '@angular/router';
import {
  ExampleStampDialogComponent,
  ExampleStampPopupComponent,
} from '@entities/example-stamp/example-stamp-dialog/example-stamp-dialog.component';
import {
  ExampleStampDeleteDialogComponent,
  ExampleStampDeletePopupComponent,
} from '@entities/example-stamp/example-stamp-delete-dialog/example-stamp-delete-dialog.component';

const ENTITY_STATES = [...ExampleStampRoute];

@NgModule({
  declarations: [
    ExampleStampComponent,
    ExampleStampDialogComponent,
    ExampleStampDeletePopupComponent,
    ExampleStampDeleteDialogComponent,
    ExampleStampPopupComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(ENTITY_STATES as Routes),
  ],
  entryComponents: [
    ExampleStampDialogComponent,
    ExampleStampDeleteDialogComponent,
  ],
})
export class ExampleStampModule {}
